import { Component, AfterViewInit, DoCheck, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { SalesGroupService } from '../../../service/sales-group/sales-group.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { TypeTaxService } from '../../../service/type-tax/type-tax.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9167',
  templateUrl: './wa9167.component.html',
  styleUrls: ['./wa9167.component.scss']
})
export class Wa9167Component implements AfterViewInit, DoCheck, OnChanges {
  public componentTitle = 'WA9167:荷主別売上摘要マスタ登録';

  // drop down list
  public owners: any;
  public salesgroups: any;
  public typetaxs: any;
  public ownerId: number;
  public ownerTx: string;
  public owner;
  public ownerdisplayTx: FormControl;
  public salesgroupId: number;
  public salesgroupTx: string;
  public salesgroupdisplayTx: FormControl;
  public unitpricedispNr: FormControl;
  public typetaxCd: FormControl;
  public filteredOwnerOptions: Observable<string[]>;
  public filteredSalesgroupOptions: Observable<string[]>;
  public validation = validation;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public unitpricedispNrCls = '';
  private errorInfo = '';
  private openotherwindow: boolean = false;
  @Output() onSubmitClick = new EventEmitter();
  @Input() selectedOwnerId;
  @Input()
  public isShow = false;
  public selectId: number;

  private isDelayHide = true;
  @Output() closeButtonClick = new EventEmitter<boolean>();

  constructor(
    private salesGroupOwnerService: SalesGroupOwnerService,
    private ownerService: OwnerService,
    private salesgroupService: SalesGroupService,
    private typetaxService: TypeTaxService,
    private commonService: CommonService,
  ) {
    // sessionStorage.removeItem('wa9167openotherwindow');
    this.ownerdisplayTx = new FormControl('', Validators.required);
    this.salesgroupdisplayTx = new FormControl('', Validators.required);
    (this.unitpricedispNr = new FormControl('', [
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.unitpricedispNr.maxNr),
      Validators.min(validation.unitpricedispNr.minNr)
    ])),
      (this.typetaxCd = new FormControl('', Validators.required));

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  ngOnChanges() {

    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);

    }
  }

  initDatas() {
    this.selectedOwnerId = undefined;
    if (sessionStorage.getItem('ownerResult'))
      this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
    if (this.selectedOwnerId !== null && this.selectedOwnerId !== undefined) {
      this.ownerService
        .get()
        .then(outputJson => {
          this.selectId = this.selectedOwnerId;
          this.owners = outputJson.owners;
          let owner = JSON.parse(sessionStorage.getItem('ownerResult'));
          this.owner = this.owners.filter((item, index) => {
            if (item.ownerId === this.selectedOwnerId) return true;
          });
          this.ownerId = this.selectedOwnerId;
          this.selectedOwnerId = 0;
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    } else {
      this.ownerService
        .get()
        .then(outputJson => {
          this.selectId = undefined;
          this.owners = outputJson.owners;
          this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(null).map(val => (val ? this.ownerFilter(val) : this.owners));
          this.selectedOwnerId = 0;
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
        var ownerResult = sessionStorage.getItem('ownerResult');
        if (ownerResult !== null) {
          const selectedOwner = JSON.parse(ownerResult);
          this.selectId = selectedOwner.ownerId;
          this.ownerId = selectedOwner.ownerId;
        }

        if (this.ownerId !== undefined) {
          let owner = JSON.parse(sessionStorage.getItem('ownerResult'));
          this.owner = this.owners.filter((item, index) => {
            if (owner !== null)
              if (item.ownerId === owner.ownerId) return true;
          });

        } else {
          this.ownerService
            .get()
            .then(outputJson => {
              this.owners = outputJson.owners;
              this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(null).map(val => (val ? this.ownerFilter(val) : this.owners));
            })
            .catch(error => {
              this.errorInfo = this.commonService.getErrorMessage(error);
            });
        }
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });


    this.salesgroupService
      .get()
      .then(_outputJson => {
        this.salesgroups = _outputJson.salesgroups;
        this.filteredSalesgroupOptions = this.salesgroupdisplayTx.valueChanges.startWith(null).map(val => (val ? this.salesgroupFilter(val) : this.salesgroups));
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typetaxService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.typetaxs = __outputJson.typetaxs;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    let errors = false;
    if (this.selectId === undefined) {
      if (this.ownerdisplayTx.errors !== null) {
        this.ownerdisplayTx.markAsTouched({ onlySelf: true });
        errors = true;
      }
    }

    if (this.salesgroupdisplayTx.errors !== null) {
      this.salesgroupdisplayTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.unitpricedispNr.errors !== null) {
      this.unitpricedispNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typetaxCd.errors !== null) {
      this.typetaxCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.salesGroupOwnerService
      .post(this.ownerId, this.ownerTx, this.salesgroupId, this.salesgroupTx, this.unitpricedispNr.value, this.typetaxCd.value, 'wa9167')
      .then(outputJson => {
        this.cancel();
        this.onView();
        this.closeButtonClick.emit(true);
        //this.onSubmitClick.emit();
        sessionStorage.setItem('isShowOwnerSelect', 'true');
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ownerFilter(val: string): string[] {
    return this.owners.filter(owner => owner.ownerdisplayTx.indexOf(val) !== -10000);
  }

  salesgroupFilter(val: string): string[] {
    return this.salesgroups.filter(salesgroup => salesgroup.salesgroupdisplayTx.indexOf(val) !== -10000);
  }

  changeOwner(event: string) {
    this.errorInfo = '';

    this.ownerId = this.getOwnerId();
    this.ownerTx = this.getOwnerTx();
  }

  changeSalesgroup(event: string) {
    this.errorInfo = '';

    this.salesgroupId = this.getSalesgroupId();
    this.salesgroupTx = this.getSalesgroupTx();
  }

  getOwnerId(): number {
    if (this.owners !== undefined && this.ownerdisplayTx.value.trim() !== '') {
      var selectedOwners = this.owners.filter((item, index) => {
        if (item.ownerdisplayTx === this.ownerdisplayTx.value.trim()) return true;
      });

      if (selectedOwners.length > 0) {
        return selectedOwners[0]['ownerId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getOwnerTx(): string {
    if (this.owners !== undefined && this.ownerdisplayTx.value.trim() !== '') {
      var selectedOwners = this.owners.filter((item, index) => {
        if (item.ownerdisplayTx === this.ownerdisplayTx.value.trim()) return true;
      });
      if (selectedOwners.length > 0) {
        return selectedOwners[0]['ownerTx'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getSalesgroupId(): number {
    if (this.salesgroups !== undefined && this.salesgroupdisplayTx.value.trim() !== '') {
      var selectedSalesgroups = this.salesgroups.filter((item, index) => {
        if (item.salesgroupdisplayTx === this.salesgroupdisplayTx.value.trim()) return true;
      });
      if (selectedSalesgroups.length > 0) {
        return selectedSalesgroups[0]['salesgroupId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getSalesgroupTx(): string {
    if (this.salesgroups !== undefined && this.salesgroupdisplayTx.value.trim() !== '') {
      var selectedSalesgroups = this.salesgroups.filter((item, index) => {
        if (item.salesgroupdisplayTx === this.salesgroupdisplayTx.value.trim()) return true;
      });
      if (selectedSalesgroups.length > 0) {
        return selectedSalesgroups[0]['salesgroupTx'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  ngDoCheck() {


    this.unitpricedispNrCls = this.unitpricedispNr.errors == null ? (this.unitpricedispNr.value != null && (this.unitpricedispNr.value + '').length > 0 ? 'active' : '') : 'error';

    if (
      (this.ownerdisplayTx.value !== '' || this.selectId !== undefined)
      && this.salesgroupdisplayTx.value !== ''
      && this.unitpricedispNrCls === 'active'
      && this.typetaxCd.value !== '') {
      this.working = true;
    } else {
      this.working = false;
    }
  }

  cancel() {
    //sessionStorage.removeItem('wa9167openotherwindow');
    sessionStorage.setItem('isShowOwnerSelect', 'true');
    this.closeButtonClick.emit(false);
    /*
    this.isS = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    */
    this.errorInfo = '';

    this.ownerdisplayTx = new FormControl('', Validators.required);
    this.salesgroupdisplayTx = new FormControl('', Validators.required);
    this.unitpricedispNr = new FormControl('', [
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.unitpricedispNr.maxNr),
      Validators.min(validation.unitpricedispNr.minNr)
    ]);
    this.typetaxCd = new FormControl('', Validators.required);
  }

  clrErr() {
    this.errorInfo = '';
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9167/wa9167.component.ts